import { render, staticRenderFns } from "./PersonHeader.vue?vue&type=template&id=0634997b&scoped=true&"
import script from "./PersonHeader.vue?vue&type=script&lang=js&"
export * from "./PersonHeader.vue?vue&type=script&lang=js&"
import style0 from "./PersonHeader.vue?vue&type=style&index=0&id=0634997b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0634997b",
  null
  
)

export default component.exports